import { eDiscoveryUrl } from 'src/common/routes';
import { Navigate } from 'react-router-dom';
import useToken from 'src/common/useToken';
import moment from 'moment';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { captureLogout } from 'src/common/analytics';

export default function ProtectedRoute(props) {
  const { token } = useToken();

  const Expiretime = Number(localStorage.getItem('Expiretime'));
  const newtime = Date.now();

  const startDate = moment(Expiretime);
  const timeEnd = moment(newtime);
  const diff = timeEnd.diff(startDate);
  const diffDuration = moment.duration(diff);
  // Use asMinutes() for the TOTAL elapsed minutes. minutes() only returns the
  // minutes component (0–59), so idle periods past an hour (e.g. 65 min) would
  // wrongly report a small value and bypass the 30-minute expiry.
  const diffMin = diffDuration.asMinutes();
  //alert(diffMin);
  //alert(diffMin);

  if (diffMin > 30) {
    captureLogout('session_expired');
    const selectedLanguage = localStorage.getItem('language');
    const languageType = localStorage.getItem('languageType');
    localStorage.clear();
    localStorage.setItem('language', selectedLanguage);
    localStorage.setItem('languageType', languageType);
    setGlobalState('loggedin', false);
    setGlobalState('sessionerror', 'Unauthorized');
    return <Navigate to={eDiscoveryUrl.Login} replace />;
  }

  if (!token) {
    return <Navigate to={eDiscoveryUrl.Login} replace />;
  }

  return props.children;
}

export function SessionMaintained(props) {
  const { token } = useToken();
  const URL = window.location.href;
  // //console.log(URL);
  if (URL.includes('Documentview')) {
    // // //console.log('Shery');
  } else {
    if (token) {
      return <Navigate to={eDiscoveryUrl.CaseS3 + '/1'} replace />;
    }
  }

  return props.children;
}
